export default __webpack_public_path__ + "static/media/css.bccfd73e.png";